import { EntityRepository, Repository } from "typeorm";
import { GradeInventoryLog } from "../entities/grade-inventory-log";

@EntityRepository(GradeInventoryLog)
export class GradeInventoryLogRepository extends Repository<GradeInventoryLog> {

    
}